<div class="activity-container" *ngIf="!isLoading; else loading">
    <h2>Delivery Activities</h2>
  
    <table mat-table [dataSource]="activities" class="mat-elevation-z8 full-width">
      <ng-container matColumnDef="trackingId">
        <th mat-header-cell *matHeaderCellDef>Tracking ID</th>
        <td mat-cell *matCellDef="let a">{{ a.trackingId }}</td>
      </ng-container>
  
      <ng-container matColumnDef="sender">
        <th mat-header-cell *matHeaderCellDef>Sender</th>
        <td mat-cell *matCellDef="let a">{{ a.customerName }}</td>
      </ng-container>
  
      <ng-container matColumnDef="receiver">
        <th mat-header-cell *matHeaderCellDef>Receiver</th>
        <td mat-cell *matCellDef="let a">{{ a.receiverName }}</td>
      </ng-container>
  
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let a">{{ a.status }}</td>
      </ng-container>
  
      <ng-container matColumnDef="rider">
        <th mat-header-cell *matHeaderCellDef>Assigned Rider</th>
        <td mat-cell *matCellDef="let a">{{ a.assignedRiderName || 'Unassigned' }}</td>
      </ng-container>
  
      <ng-container matColumnDef="paid">
        <th mat-header-cell *matHeaderCellDef>Paid</th>
        <td mat-cell *matCellDef="let a">
          <span [ngClass]="a.isPaid ? 'paid' : 'unpaid'">
            {{ a.isPaid ? 'Paid' : 'Unpaid' }}
          </span>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let a">
          <button mat-icon-button [matMenuTriggerFor]="activityActionsMenu" matTooltip="Activity Actions" [disabled]="!canManageAction()">
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #activityActionsMenu="matMenu">
            <button mat-menu-item (click)="openManageDialog(a)" [disabled]="!canManageAction()">
              <mat-icon>edit</mat-icon>
              <span>Manage Activity</span>
            </button>
            <button mat-menu-item *ngIf="canUpdateStatus()" (click)="markAsPaid(a)" [disabled]="a.isPaid">
              <mat-icon>payments</mat-icon>
              <span>Mark as Paid</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="['trackingId','sender','receiver','status','rider','paid','actions']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['trackingId','sender','receiver','status','rider','paid','actions'];"></tr>
    </table>
  </div>
  
  <ng-template #loading>
    <div class="loading">Loading activities...</div>
  </ng-template>
  
